import { Button, EmptyState } from '@bp/ui-components';
import { useContext } from 'react';
import { OrganizationConfigContext } from '../../context/OrganizationConfigContext';
import { usePermissionChecker } from '../../hooks/usePermissionChecker';
import { FragmentType, getFragmentData, graphql } from '../../client/gql';

const LinkListFieldsDocument = graphql(`
  fragment LinkListFields on Query {
    ...PermissionCheckerFields
  }
`);

type LinkListProps = {
  className?: string | undefined;
  query: FragmentType<typeof LinkListFieldsDocument> | undefined;
};

export const LinkList = ({ className, query }: LinkListProps) => {
  const fragment = getFragmentData(LinkListFieldsDocument, query);
  const { cloudLicense, cloudLink } = useContext(OrganizationConfigContext);
  const perms = usePermissionChecker(fragment);

  const nextcloudLink = cloudLicense && perms?.canAccessCloud() && cloudLink ? cloudLink : undefined;

  return (
    <>
      {nextcloudLink && <Button>Cloud</Button>}
      <EmptyState
        className={className}
        subtitle='Hier erscheinen in Zukunft wichtige Links'
        hideIcon
        fitParent
        forcedHeight={'140px'}
      />
    </>
  );
};
